import React, { useEffect, useRef, useState } from 'react'
import { Button, Col, Form } from 'react-bootstrap'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js'
import { api_gateway } from '../../../conexoes/api'
import { revelarNovaRegra } from '../../../redux/actions/index'
import { useGlobal } from '../../../stores/useGlobal.js'
import {
  elipseVerde,
  fecharJanela,
  setaDropdown
} from '../../../utils/alternanciaIcones'
import decryptJWT from '../../../utils/decryptJWT'
import MensagemAtencao from '../../componentesModais/mensagens/mensagemAtencao.js'
import MensagemErro from '../../componentesModais/mensagens/mensagemErro'
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso'
import SelectGenericoCheckbox from '../../componentesModais/selects/selectGenericoCheckbox'
import SelectNivelImportancia from '../../componentesModais/selects/selectNivelImportancia'
import SelectParametro from '../../componentesModais/selects/selectParametro'
import SelectRegraAutomacao from '../../componentesModais/selects/selectRegraAutomacao'

const cd_tipo_envio = ['6', '5', '3']

export default function NovaRegra(props) {
  const { setIsLoadingGlobal } = useGlobal()

  const { handleSubmit } = useForm()
  const [arrayCdUsuario] = useState([])
  const [dsParametro, setDsParametro] = useState()
  const [cdAutEvento, setCdAutEvento] = useState()
  const [dsAutEvento, setDsAutEvento] = useState('Selecione')
  const [cdAutEventoParametro, setCdAutEventoParametro] = useState()
  const [cdAutEventoParametroValor, setCdAutEventoParametroValor] = useState()
  const [dsValor, setDsValor] = useState()
  const [cdAutRegraNivel, setCdAutRegraNivel] = useState()
  const [cdAutRegraUsuario] = useState([])
  const [flRegraAutomacao, setFlRegraAutomacao] = useState([])
  const [dsNivelImportancia, setDsNivelImportancia] = useState('Selecione')
  const [arrayDsUsuarioAutomacao] = useState([])
  const [dsUsuarioAutomacao, setDsUsuarioAutomacao] = useState('Selecione')
  const [formaEnvioEmail] = useState()
  const [formaEnvioNotificacao] = useState()
  const [formaEnvioPlataforma] = useState()
  const [perfilPrecedencia, setPerfilPrecedencia] = useState(0)
  const [arrayDummy] = useState()
  const [revelarSelectRegraAutomacao, setRevelarSelectRegraAutomacao] =
    useState(false)
  const [revelarSelectParametro, setRevelarSelectParametro] = useState(false)
  const [revelarSelectNivelImportancia, setRevelarSelectNivelImportancia] =
    useState(false)
  const [revelarSelectUsuarioAutomacao, setRevelarSelectUsuarioAutomacao] =
    useState(false)
  const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
  const [
    revelarAlertaNotificacaoBloqueada,
    setRevelarAlertaNotificacaoBloqueada
  ] = useState(false)
  const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
  const despacho = useDispatch()
  const modal = useRef()
  const [mensagemErro, setMensagemErro] = useState(
    'Ocorreu um erro ao executar esta ação'
  )
  const flAtivoRegraAcao = ['0', '0', '0']

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      handleCancelar()
    }
  }

  async function handleCancelar() {
    ColetaClickstream(1255) // 'dropAcoesRevelarNovaRegraCancelar'
    props.setRenderizar(props.renderizar + 1)
    setRevelarMensagemErro(false)
    setRevelarMensagemSucesso(false)
    despacho(revelarNovaRegra(false))
  }

  async function handleSalvar() {
    setIsLoadingGlobal(true)
    ColetaClickstream(1256) // 'dropAcoesRevelarNovaRegraConfirmar'
    let arrayCdAutRegraAcao = []

    cd_tipo_envio.map((item, i) => {
      arrayCdAutRegraAcao.push({
        cd_aut_acao: cd_tipo_envio[i],
        FL_ATIVO_REGRA_ACAO: flAtivoRegraAcao[i]
      })
    })

    let arrayCdPavUsuario = []

    if (arrayCdUsuario.length > cdAutRegraUsuario.length) {
      arrayCdUsuario.map((item, i) => {
        if (arrayCdUsuario[i] != -1)
          arrayCdPavUsuario.push({
            cd_pav_usuario: arrayCdUsuario[i],
            cd_aut_regra_usuario: cdAutRegraUsuario[i]
          })
      })
    } else {
      cdAutRegraUsuario.map((item, i) => {
        if (arrayCdUsuario[i] != -1)
          arrayCdPavUsuario.push({
            cd_pav_usuario: arrayCdUsuario[i],
            cd_aut_regra_usuario: cdAutRegraUsuario[i]
          })
      })
    }

    await api_gateway
      .post('/m1/cadastrar/aut_regra', {
        cd_aut_evento: cdAutEvento,
        cd_aut_regra_nivel: cdAutRegraNivel,
        cd_aut_regra_acao: arrayCdAutRegraAcao,
        cd_aut_evento_parametro: cdAutEventoParametro,
        cd_aut_evento_parametro_valor: cdAutEventoParametroValor,
        ds_valor: dsValor,
        cd_pav_usuario_alerta: arrayCdPavUsuario
      })
      .then(function () {
        setRevelarMensagemSucesso(true)
        setIsLoadingGlobal(false)
      })
      .catch(function (error) {
        setMensagemErro(error.response.data.info)
        setRevelarMensagemErro(true)
        setIsLoadingGlobal(false)
      })
  }

  async function handleAlterarSwitches(cdSwitch, flAtivo) {
    let auxAtivo = '0'
    if (flAtivo === true) {
      auxAtivo = '1'
    }

    if (cdSwitch === '5' && flAtivo) {
      const isEdge = /Edg/i.test(navigator.userAgent)

      const isDefault = Notification.permission === 'default'
      const isDenied = Notification.permission === 'denied'

      if (isEdge && (isDefault || isDenied)) {
        setMensagemErro(
          'Para receber notificações, ative-as nas configurações do site no seu navegador.'
        )
        setRevelarAlertaNotificacaoBloqueada(true)
        return
      }

      if (isDefault) {
        await Notification.requestPermission()
      } else if (isDenied) {
        setMensagemErro(
          'As notificações estão bloqueadas. Por favor, ative-as nas configurações do site para receber os alertas.'
        )
        setRevelarAlertaNotificacaoBloqueada(true)
      }
    }

    cd_tipo_envio.map((item, i) => {
      if (item == cdSwitch) {
        flAtivoRegraAcao[i] = auxAtivo
      }
    })
  }

  useEffect(() => {
    function handleMudarFlagRegra() {
      setDsParametro('Selecione')
      setCdAutEventoParametro(undefined)
      setCdAutEventoParametroValor(undefined)
      setDsValor(undefined)
    }
    handleMudarFlagRegra()
  }, [flRegraAutomacao])

  useEffect(() => {
    function handleCriarNivelSelecionado() {
      if (cdAutRegraNivel === 3) {
        setDsNivelImportancia(
          <div className="select-nivel-importancia-container-esfera">
            <div className="select-nivel-importancia-esfera-verde" />
            <p className="fonte-cor-1 nao-selecionavel">Normal</p>
          </div>
        )
      } else if (cdAutRegraNivel === 2) {
        setDsNivelImportancia(
          <div className="select-nivel-importancia-container-esfera">
            <div className="select-nivel-importancia-esfera-amarela" />
            <p className="fonte-cor-1 nao-selecionavel">Atenção</p>
          </div>
        )
      } else if (cdAutRegraNivel === 1) {
        setDsNivelImportancia(
          <div className="select-nivel-importancia-container-esfera">
            <div className="select-nivel-importancia-esfera-vermelha" />
            <p className="fonte-cor-1 nao-selecionavel">Urgente</p>
          </div>
        )
      }
    }
    handleCriarNivelSelecionado()
  }, [cdAutRegraNivel])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function handleMensagemErro() {
    if (revelarMensagemErro === false) {
      setRevelarMensagemErro(true)
    } else {
      setRevelarMensagemErro(false)
    }
  }

  function handleMensagemSucesso(confirmacao) {
    if (revelarMensagemSucesso === false) {
      setRevelarMensagemSucesso(true)
    } else {
      setRevelarMensagemSucesso(false)
      if (confirmacao === true) {
        handleCancelar()
      }
      handleCancelar()
    }
  }

  useEffect(() => {
    hendlerPerfil()
  }, [])

  async function hendlerPerfil() {
    await api_gateway
      .get('/m1/consultar/perfil?cd_pav_perfil=' + decryptJWT('perfil'))
      .then((response) => {
        if (response.data.status == 200 && response.data.dados.length > 0) {
          setPerfilPrecedencia(response.data.dados[0].n0_precedencia)
        }
      })
  }

  useEffect(() => {
    if (arrayDsUsuarioAutomacao.length > 0) {
      setDsUsuarioAutomacao(arrayDsUsuarioAutomacao[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrayDsUsuarioAutomacao[0]])

  return (
    <Form ref={modal} onSubmit={handleSubmit(() => handleSalvar())}>
      <div className="modal-acao-nova-editar-regra-automacao fundo-cor-6">
        <Form.Row>
          <Col>
            <img
              className="icone-label-janela nao-selecionavel"
              src={elipseVerde()}
              alt="elipse"
            />
            <Form.Label>
              <div className="fonte-cor-1 label-janela">Nova regra</div>
            </Form.Label>
            <Button
              className="botao-fechar-janela"
              variant="danger"
              onClick={() => handleCancelar()}
            >
              <img
                className="botao-fechar-janela-icone"
                src={fecharJanela()}
                alt="fechar-janela"
              />
            </Button>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="grupo-nova-editar-regra-automacao-1">
              <div className="coluna-nova-editar-regra-automacao-1">
                <Form.Group>
                  <Form.Label>
                    <div className="fonte-cor-1 label-campo">Regra</div>
                  </Form.Label>
                  {revelarSelectRegraAutomacao === false && (
                    <Button
                      name="cdRegraAutomacao"
                      className="campo-texto-cor-3 campo-select"
                      onClick={() =>
                        setRevelarSelectRegraAutomacao(
                          !revelarSelectRegraAutomacao
                        )
                      }
                    >
                      <div className="fonte-cor-1 label-campo">
                        {dsAutEvento}
                      </div>
                      <img
                        className="campo-select-icone-desativado"
                        src={setaDropdown()}
                        alt="drop"
                      />
                    </Button>
                  )}
                  {revelarSelectRegraAutomacao === true && (
                    <SelectRegraAutomacao
                      setRevelarSelectRegraAutomacao={
                        setRevelarSelectRegraAutomacao
                      }
                      setCdRegraAutomacao={setCdAutEvento}
                      setDsRegraAutomacao={setDsAutEvento}
                      setFlRegraAutomacao={setFlRegraAutomacao}
                      dsRegraAutomacao={dsAutEvento}
                    />
                  )}
                </Form.Group>
              </div>
              <div className="coluna-nova-editar-regra-automacao-2">
                {flRegraAutomacao != 0 && (
                  <Form.Group>
                    <Form.Label>
                      <div className="fonte-cor-1 label-campo">Parâmetro</div>
                    </Form.Label>
                    {revelarSelectParametro === false && (
                      <Button
                        name="cdParametro"
                        className="campo-texto-cor-3 campo-select"
                        onClick={() =>
                          setRevelarSelectParametro(!revelarSelectParametro)
                        }
                      >
                        <div className="fonte-cor-1 label-campo">
                          {dsParametro}
                        </div>
                        <img
                          className="campo-select-icone-desativado"
                          src={setaDropdown()}
                          alt="drop"
                        />
                      </Button>
                    )}
                    {revelarSelectParametro === true && (
                      <SelectParametro
                        setRevelarSelectParametro={setRevelarSelectParametro}
                        setDsParametro={setDsParametro}
                        dsParametro={dsParametro}
                        cdAutEvento={cdAutEvento}
                        setDsValor={setDsValor}
                        setCdAutEventoParametro={setCdAutEventoParametro}
                        setCdAutEventoParametroValor={
                          setCdAutEventoParametroValor
                        }
                      />
                    )}
                  </Form.Group>
                )}
              </div>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="campo-select-divisor-cor-2 nova-editar-regra-automacao-divisor" />
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="grupo-nova-editar-regra-automacao-1">
              <div className="coluna-nova-editar-regra-automacao-1">
                <Form.Group>
                  <Form.Label>
                    <div className="fonte-cor-1 label-campo">
                      Nível de importância
                    </div>
                  </Form.Label>
                  {revelarSelectNivelImportancia === false && (
                    <Button
                      name="cdAutRegraNivel"
                      className="campo-texto-cor-3 campo-select"
                      onClick={() =>
                        setRevelarSelectNivelImportancia(
                          !revelarSelectNivelImportancia
                        )
                      }
                    >
                      <div className="fonte-cor-1 label-campo">
                        {dsNivelImportancia}
                      </div>
                      <img
                        className="campo-select-icone-desativado"
                        src={setaDropdown()}
                        alt="drop"
                      />
                    </Button>
                  )}
                  {revelarSelectNivelImportancia === true && (
                    <SelectNivelImportancia
                      setRevelarSelectNivelImportancia={
                        setRevelarSelectNivelImportancia
                      }
                      setCdNivelImportancia={setCdAutRegraNivel}
                      dsNivelImportancia={dsNivelImportancia}
                    />
                  )}
                </Form.Group>
              </div>
              <div className="coluna-nova-editar-regra-automacao-2">
                <Form.Group>
                  <Form.Label>
                    <div className="fonte-cor-1 label-campo">Usuários</div>
                  </Form.Label>
                  {revelarSelectUsuarioAutomacao === false && (
                    <Button
                      name="cdUsuarioAutomacao"
                      className="campo-texto-cor-3 campo-select"
                      onClick={() =>
                        setRevelarSelectUsuarioAutomacao(
                          !revelarSelectUsuarioAutomacao
                        )
                      }
                    >
                      <div className="fonte-cor-1 label-campo">
                        {dsUsuarioAutomacao}
                      </div>
                      <img
                        className="campo-select-icone-desativado"
                        src={setaDropdown()}
                        alt="drop"
                      />
                    </Button>
                  )}
                  {revelarSelectUsuarioAutomacao === true && (
                    <SelectGenericoCheckbox
                      paramRota="usuario_relacionamento"
                      paramCampo1={perfilPrecedencia}
                      paramCampo2={null}
                      paramCampo3={null}
                      paramCampo4={null}
                      arrayCodigo={arrayCdUsuario}
                      arrayDescricao1={arrayDsUsuarioAutomacao}
                      arrayDescricao2={arrayDummy}
                      arrayDescricao3={arrayDummy}
                      arrayDescricao4={arrayDummy}
                      setRevelarSelect={setRevelarSelectUsuarioAutomacao}
                      placeholder={dsUsuarioAutomacao}
                      sufixo=""
                    />
                  )}
                </Form.Group>
              </div>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="campo-select-divisor-cor-2 nova-editar-regra-automacao-divisor" />
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Form.Label>
              <div className="fonte-cor-1 label-campo">Forma de envio</div>
            </Form.Label>
            <div className="container-switch-nova-editar-regra-automacao">
              <div className="flipswitch">
                <input
                  type="checkbox"
                  defaultChecked={formaEnvioEmail}
                  name="flipswitch"
                  className="flipswitch-cb"
                  id="switchEmail"
                  onClick={(e) => handleAlterarSwitches('6', e.target.checked)}
                />
                <label className="flipswitch-label" htmlFor="switchEmail">
                  <div className="flipswitch-inner flipswitch-cor-1" />
                  <div className="flipswitch-switch" />
                </label>
              </div>
              <div className="fonte-cor-1 label-termos-nova-editar-regra-automacao">
                {' '}
                E-mail
              </div>
            </div>
          </Col>
          <Col>
            <div className="container-switch-nova-editar-regra-automacao-2">
              <div className="flipswitch">
                <input
                  type="checkbox"
                  defaultChecked={formaEnvioNotificacao}
                  name="flipswitch"
                  className="flipswitch-cb"
                  id="switchNotificacao"
                  onClick={(e) => handleAlterarSwitches('5', e.target.checked)}
                />
                <label className="flipswitch-label" htmlFor="switchNotificacao">
                  <div className="flipswitch-inner flipswitch-cor-1" />
                  <div className="flipswitch-switch" />
                </label>
              </div>
              <div className="fonte-cor-1 label-termos-nova-editar-regra-automacao">
                {' '}
                Notificação
              </div>
            </div>
          </Col>
          <Col>
            <div className="container-switch-nova-editar-regra-automacao-2">
              <div className="flipswitch">
                <input
                  type="checkbox"
                  defaultChecked={formaEnvioPlataforma}
                  name="flipswitch"
                  className="flipswitch-cb"
                  id="swithPlataforma"
                  onClick={(e) => handleAlterarSwitches('3', e.target.checked)}
                />
                <label className="flipswitch-label" htmlFor="swithPlataforma">
                  <div className="flipswitch-inner flipswitch-cor-1" />
                  <div className="flipswitch-switch" />
                </label>
              </div>
              <div className="fonte-cor-1 label-termos-nova-editar-regra-automacao">
                {' '}
                Plataforma
              </div>
            </div>
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <div className="campo-select-divisor-cor-2 nova-editar-regra-automacao-divisor" />
          </Col>
        </Form.Row>
        <Form.Row>
          <Col>
            <Button
              type="submit"
              className="botao-confirmar"
              variant="success"
              size="sm"
            >
              <div className="fonte-cor-4">Confirmar</div>
            </Button>
            <Button
              className="botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar()}
            >
              <div className="fonte-cor-2">Cancelar</div>
            </Button>
          </Col>
        </Form.Row>
      </div>
      {revelarMensagemSucesso && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemSucesso
              handleMensagemSucesso={handleMensagemSucesso}
              mensagemTitulo="Sucesso"
              mensagemParagrafo1="Regra cadastrada"
              mensagemBotao="Finalizar"
            />
          </div>
        </div>
      )}
      {revelarMensagemErro && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemErro
              centralizarBotao
              handleMensagemErro={handleMensagemErro}
              mensagemTitulo={mensagemErro}
              mensagemParagrafo1="Algo deu errado!"
              mensagemParagrafo2="Por favor, tente mais tarde."
              mensagemParagrafo3={mensagemErro}
              mensagemBotao="Retornar"
            />
          </div>
        </div>
      )}
      {revelarAlertaNotificacaoBloqueada && (
        <div className="componente-modal-overlay">
          <div className="componente-modal">
            <MensagemAtencao
              semBotaoCancelar
              handleMensagemAtencao={() =>
                setRevelarAlertaNotificacaoBloqueada(false)
              }
              mensagemTitulo="Atenção"
              mensagemParagrafo1={mensagemErro}
              mensagemBotao="Fechar"
            />
          </div>
        </div>
      )}
    </Form>
  )
}
